import React, { Component, Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authActions, alertActions } from '../../store/actions';
import { history } from '../../helpers/history';
import Footer from '../../components/Footer/footer';
import { validationEmail } from '../../helpers/response';

import { PatientDesiredRole, enableGA } from '../../config';
import clip from '../../static/images/Saaya_Final.mp4';
import defaultImage from '../../static/images/default_BG.png';
import '../../static/css/styles.css';
import '../../components/Modal/modal.css';
import { WhitelabelActions } from '../../store/actions';
import Loading from '../../components/Loading/Loading';
import { ANALYTICS_EVENTS, constants } from '../../Constants';
import { Counsellor_Portal_URL, Sub_Domain } from '../../config';
import ReactGA from 'react-ga';
import { pateintLogin } from '../../helpers/ConstantID';
import { WhitelabelService } from '../../services';
import { UnAuthenticatedHeader } from '../../components/HeaderUnAunthicated';
import { getSubDomain } from '../../helpers';
import { pushToDataLayer } from '../../helpers/analytics';

const Image = lazy(() => import('../../components/Image/index'));
class LogIn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_domain: '@khi.iba.edu.pk',
			email_address: '',
			password: '',
			submitted: false,
			desiredRole: PatientDesiredRole,
			showModal: false,
			modalClosed: false,
			loading: true,
			is_mobile: false,
			error_email:false,
			error_pwd:false,
			is_bv_domain:false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleRadioButton = this.handleRadioButton.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	componentWillMount() {
		if (window.location.hostname.indexOf(Sub_Domain) > -1) {
			if (this.props.location.state) {
				const { state } = this.props.location;
			
				if (state.requestSession && state.slot && state.patientId)
					history.push({
						pathname: '/login/counsellor',
						state: {
							requestSession: state.requestSession,
							slot: state.slot,
							patientId: state.patientId,
						},
					});
			} else {
				history.push({
					pathname: '/login/counsellor',
					state: {},
				});
			}
		}
		this.props.fetchWhitelabel();
		const user = JSON.parse(localStorage.getItem('user'));
		if (user === null) {
			const subDomain = getSubDomain();
			if (subDomain) {
				pushToDataLayer(ANALYTICS_EVENTS.PAGE_VISITS.LOGIN_PAGE, {
					sub_domain: subDomain,
				});	  
			}
		} else {
			if (user.role === 0) {
				history.replace('/home/counsellor');
			}
			if (user.role === 1) {
				history.replace('/home');
			}
		}
	}

	componentDidMount() {

		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
		
		// on Boarding
		const urlLink = window.location.href.toString().includes(constants.EMAIL);
		if (urlLink) {
			const onboardingLoginEmail = window.location.pathname.split('=')[1];

			if (validationEmail(onboardingLoginEmail)) {
				this.props.getOnBoardingStatus(onboardingLoginEmail);
				this.setState({
					email_address: onboardingLoginEmail,
					isApiCalled: true,
				});
			}
		} else {
			this.setState({
				showModal: false,
				isApiCalled: false,
				modalClosed: true,
				loading: false,
			});
		}

		if (window.location.host === "bv.saayahealther.com" || window.location.host === "bv.saayahealth.com"){
			this.setState({
				is_bv_domain:true
			})
		}

		// clear alert on location change
		this.props.clearAlertActions();

		document.addEventListener("keydown", this.onPressEnter);
	}

	componentWillUnmount(){
		document.removeEventListener("keydown", this.onPressEnter);
	}

	componentWillReceiveProps(nextProps) {
		// on Boarding
		if (nextProps.whitelabel && nextProps.whitelabel.length > 0) {
			const { modalClosed } = this.state;
			const subDomain = nextProps.whitelabel[0].sub_domain.toLowerCase();
			if (subDomain.indexOf(constants.PAKQATAR.toLowerCase()) > -1) {
				if (
					nextProps.authstate.response &&
					nextProps.authstate.response.is_verified !== null &&
					nextProps.authstate.response.is_verified !== undefined
				) {
					if (!modalClosed) {
						if (!nextProps.authstate.response.is_verified) {
							this.setState({
								loading: false,
								showModal: true,
								isApiCalled: false,
								modalClosed: false,
							});
						} else {
							this.setState({
								loading: false,
								showModal: false,
								isApiCalled: false,
							});
						}
					} else {
						this.setState({
							loading: false,
							showModal: false,
							isApiCalled: false,
						});
					}
				}
			} else {
				this.setState({
					//email_address: '',
					loading: false,
					showModal: false,
					isApiCalled: false,
				});
			}
		}
	}

	handleRadioButton(e) {
		this.setState({ email_domain: e.target.value });
	}

	forgotPassword = () => {
		history.push('/emailverification');
	};

	register = () => {
		history.push('/registration');
	};

	counsellorLogIn = () => {
		history.push('/login/counsellor');
	};

	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}

	parseEmailDomains() {
		const { whitelabel } = this.props;
		var str = whitelabel[0].email_domain;
		str = str.replace(/[\[\]']+/g, '');
		str = str.replace(/\s+/g, '');
		var email_domains_array = str.split(',');
		return email_domains_array;
	}

	getUserEmailDomain() {
		const { email_address } = this.state;
		if (validationEmail(email_address)) {
			var email_domain = email_address.split('@')[1];
			return email_domain;
		}
	}

	validateEmail() {
		var userInput = this.getUserEmailDomain();
		var parsedEmails = this.parseEmailDomains();
		for (var i = 0; i < parsedEmails.length; i++) {
			if (userInput === parsedEmails[i] || parsedEmails[i] === 'all') {
				return true;
			}
		}
		return false;
	}

	handleSubmit(ev) {
		ev.preventDefault();
		const subDomain = getSubDomain();
		if (subDomain) {
			pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.SIGN_IN_BTN, {
				sub_domain: subDomain,
			});
		}
		const { whitelabel } = this.props;
		const projectName = whitelabel[0].name;
		const { email_address, password, desiredRole, error_email, error_pwd } = this.state;
		this.setState({ submitted: true });

		if (email_address && password) {
			if (!validationEmail(email_address)) {
				this.setState({error_email:true,error_pwd:password === '' ? true : false});
				const message = constants.EMAIL_VALIDATION_MSG;
				this.props.alertError(message);
			} else if (this.validateEmail()) {
				this.setState({error_email:false,error_pwd:password === '' ? true : false});
				this.props.loginAuthentication(email_address, password, desiredRole, projectName);
			} else {
				this.setState({error_email:true,error_pwd:false});
				const message = `${constants.PLEASE_TXT} ${constants.ENTER_YOU_EMAIL.replace(
					'{0}',
					whitelabel &&
						whitelabel[0].name &&
						whitelabel[0].name.toLowerCase() !== constants.PAKQATAR.toLowerCase()
						? whitelabel[0].name
						: constants.REGISTERED
				)}`;
				this.props.alertError(message);
			}
		} else {
			this.setState({error_email:email_address === '' ? true : false,error_pwd:password === '' ? true : false});
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		}
	}

	closeModal = () => {
		// on Boarding
		this.setState({ showModal: false });
	};


	onPressEnter = (ev) =>{
		if(ev.keyCode == 13 && ev.key === "Enter"){
			this.handleSubmit(ev)
		}
	}

	render() {
		const { alert, whitelabel } = this.props;
		const {error_email,error_pwd} = this.state;
		const showError = alert.message && alert.message.length > 0;
		if (whitelabel && whitelabel[0].name && enableGA)
			ReactGA.event({
				category: 'Landing',
				action: 'Login',
				label: whitelabel[0].name,
				transport: 'beacon',
			});
		return this.state.loading ? (
			<Loading />
		) : (
			<React.Fragment>
				{/* on Boarding Starts */}
				<div className="video-root" style={{ visibility: this.state.showModal ? 'visible' : 'hidden' }}>
					<video className="video-styles" width="100%" height="100%" controls onEnded={this.closeModal}>
						<source src={clip} type="video/mp4" />
					</video>
				</div>
				{/* on Boarding Ends */}

				<UnAuthenticatedHeader/>
				<div className="sh-layout">
					<div className={`${this.state.is_bv_domain && "sh-patient-login-comp-bv-domain"} sh-patient-login-comp`}>
						<div className="sh-gnrl-inner">
							<div className="sh-gnrl-logo">
								<img
									src={whitelabel ? whitelabel[0].logo_url : defaultImage}
									alt="logo"
									id={pateintLogin.sh_pl_logo}
								/>
							</div>
							<div className="sh-plc-heading">
								<h2 className="sh-plc-h2 sh-mb-15" id={pateintLogin.sh_pl_text1}>
									{constants.SIGN_IN_TEXT}
								</h2>
								<p className="sh-plc-gnrl-text sh-mb-20" id={pateintLogin.sh_pl_text2}>
									{constants.CONTINUE_JOURNEY_TXT_1}
									<br />
									{constants.CONTINUE_JOURNEY_TXT_2}
								</p>
							</div>
							<div className="sh-plc-form">
								<div className="sh-gnrl-row sh-mb-15">
									<div className="sh-input-group">
										<input
											autocomplete="off"
											id={pateintLogin.sh_pl_email}
											value={this.state.email_address || ''}
											required
											type="email"
											name="email_address"
											onChange={this.handleChange}
											className={`sh-input-text ${error_email ? 'sh-input-error' : ''} ${
												this.state.email_address && 'sh-input-active'
											}`}
										/>
										<label htmlFor={pateintLogin.sh_pl_email} className="sh-input-label sh-login-input-label">
											{constants.EMAIL_ADDRESS}
										</label>
									</div>
								</div>

								<div className="sh-gnrl-row sh-mb-5">
									<div className="sh-input-group">
										<input
											autocomplete="off"
											id={pateintLogin.sh_pl_pass}
											required
											type="password"
											name="password"
											onChange={this.handleChange}
											className={`sh-input-text ${error_pwd ? 'sh-input-error' : ''}`}
										/>
										<label htmlFor={pateintLogin.sh_pl_pass} className="sh-input-label">
											{constants.ENTER_PASSWORD}
										</label>
									</div>
								</div>

								<div className="sh-grnl-row sh-mb-5">
									<span className="sh-gnrl-error-msg" id={"sh_error_message"}>{alert.message}</span>
								</div>

								<div className="sh-gnrl-row sh-dflex sh-mb-30">
									<div className="sh-plc-remember">
										
									</div>
									<div className="sh-plc-forgot-pass">
										<button id={pateintLogin.sh_pl_forgot_pass} onClick={this.forgotPassword}>
											{constants.FORGOT_PASSWORD}
										</button>
									</div>
								</div>

								<div className="sh-gnrl-row sh-mb-15">
									<button
										id={pateintLogin.sh_pl_sign_in_btn}
										onClick={this.handleSubmit}
										className="sh-gnrl-btn sh-login-btn"
									>
										{constants.SIGN_IN}
									</button>
								</div>

								<div className="sh-gnrl-row sh-mb-15">
									<button
										id={pateintLogin.sh_pl_reg_btn}
										className="sh-gnrl-btn sh-rgstr-btn"
										onClick={this.register}
									>
										{constants.REGISTER_MEMBER_MSG}
									</button>
								</div>

								<div className="sh-gnrl-row sh-mb-15">
									<label htmlFor={pateintLogin.sh_pl_cnslr_btn} className="sh-plc-cnslr">
										{constants.COUNSELOR_LOGIN_MSG.replace(
											'{0}',
											whitelabel && whitelabel[0]
												? whitelabel[0].producer_role
												: constants.COUNSELLOR
												
										)}
										<span className="sh-color-counsellor" id={pateintLogin.sh_cl_cnslr_sign_in}> {constants.SIGN_IN_TXT}</span>
									</label>
									<button
										className="sh-plc-cnslr-btn"
										onClick={() => (window.location = Counsellor_Portal_URL)}
										id={pateintLogin.sh_pl_cnslr_btn}
									></button>
								</div>
								<div className="sh-gnrl-row sh-mb-15 blog-faq-block">
									<label htmlFor={pateintLogin.sh_pl_cnslr_btn} className="sh-plc-cnslr">
										{constants.FAQ_TEXT}
										<a href='/faq'><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
									</label>
								</div>
								<div className="sh-gnrl-row sh-mb-15 blog-faq-block">
									<label htmlFor={pateintLogin.sh_pl_cnslr_btn} className="sh-plc-cnslr">
										{constants.VIEW_BLOGS}
										<a target={"_blank"} href='https://saayahealth.com/blog'><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
									</label>
								</div>
							</div>
						</div>
					</div>
					<Footer />
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const authstate = state.auth;
	const { whitelabel } = state.whitelabel;

	return {
		alert,
		authstate,
		whitelabel,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		getOnBoardingStatus: (onboardingLoginEmail) => {
			dispatch(authActions.getOnBoardingStatus(onboardingLoginEmail));
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		loginAuthentication: (email_address, password, desiredRole, projectName) => {
			dispatch(authActions.login(email_address, password, desiredRole, projectName));
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogIn));



// WEBPACK FOOTER //
// ./src/screens/LogIn/index.js